import React from "react";
import ReactStars from "react-rating-stars-component";
import { FaStar } from "react-icons/fa";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  starsContainer: {
    marginBottom: theme.spacing(3),
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    "& .react-stars": {
      display: "flex",
      gap: "8px",
      "& span": {
        transition: "all 0.3s ease",
        filter: "drop-shadow(0 2px 4px rgba(0,0,0,0.1))",
        "&:hover": {
          transform: "scale(1.1)",
          filter: "drop-shadow(0 4px 8px rgba(0,0,0,0.2))",
        },
      },
    },
  },
}));

function StarsComponent(props) {
  const classes = useStyles();

  return (
    <div className={classes.starsContainer}>
      <ReactStars
        count={5}
        onChange={props.ratingChanged}
        size={36}
        isHalf={false}
        emptyIcon={<FaStar />}
        fullIcon={<FaStar />}
        edit={props.editRate}
        value={props.rating}
        activeColor="#FFD700"
        color="#E0E0E0"
        classNames={{
          root: "react-stars",
        }}
      />
    </div>
  );
}

export default StarsComponent;
